var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-5/6",attrs:{"id":"p1s2c3"}},[_c('div',{staticClass:"h-full"},[_c('div',{staticClass:"rounded-xl overflow-hidden h-full"},[_c('canvas',{staticClass:"p-10",attrs:{"id":"chartBar"}})])])])
}]

export { render, staticRenderFns }